import React, { Fragment } from "react"
import SocialIcon from "./SocialIcon/SocialIcon";

// import * as styles from './SocialMedia.module.scss'

const SocialMedia = ({color}) => {
    const iconTypes = [
        'twitter',
        'youtube',
        'instagram',
        'linkedin',
        'facebook'
    ]

    return(  
        <Fragment>
            {iconTypes.map(icon => {
                return <SocialIcon iconSet={true} key={icon} type={icon} inline='true' color={color}/>
            })}
        </Fragment>
    )
}

export default SocialMedia